import styled from 'styled-components';
import { typeStyle } from '../../styles/config/typeStyles';
import { theme } from '../../styles/config/theme';
import { rgba } from 'polished';
import media from '../../styles/config/mediaQueries';

const StyledContainer = styled.div`
  padding-top: 16px;
  ${media.desktop`
		margin-bottom: 40px;
	`}
`;

const StyledCard = styled.div`
  margin-bottom: 6px;
  padding-bottom: 10px;
  background-color: ${rgba(theme.color.white, 0.03)};
  ${media.desktop`
		padding: 0 20px 10px 20px;
	`}
`;

const StyledHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

const StyledTitle = styled.h3`
  text-decoration: underline;
  ${typeStyle.h4}
`;

const StyledList = styled.ul``;

const StyledListItem = styled.li`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.5;
`;

const StyledIconButton = styled.button`
  width: 26px;
  height: 26px;
`;

export {
  StyledContainer,
  StyledCard,
  StyledHeading,
  StyledList,
  StyledListItem,
  StyledTitle,
  StyledIconButton,
};
